var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-equal.8c0b18b6.png","uri@2x": __webpack_public_path__ + "icon-equal.e5fdf7ee.png","uri@3x": __webpack_public_path__ + "icon-equal.df28719b.png",
    width: 100,
    height: 100
});